"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CaseExclusion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// React imports
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var CaseExclusion = /** @class */ (function (_super) {
    __extends(CaseExclusion, _super);
    /**
     * Constructor method for class CaseExclusion
     * @param {Accelerate.CaseExclusionProps} props
     */
    function CaseExclusion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            comment: ''
        };
        _this.caseToggleExclusion = _this.caseToggleExclusion.bind(_this);
        _this.cancelExclusion = _this.cancelExclusion.bind(_this);
        _this.handleCommentChange = _this.handleCommentChange.bind(_this);
        return _this;
    }
    /**
     * Method to handle the change event for text area element
     * @param {Object} event - Event object
     */
    CaseExclusion.prototype.handleCommentChange = function (event) {
        this.setState({ comment: event.target.value });
    };
    /**
     * Method for case exclusion
     */
    CaseExclusion.prototype.caseToggleExclusion = function () {
        this.props.onCaseExclusion(this.state.comment);
    };
    /**
     * Method for cancel the exclusion of a case
     */
    CaseExclusion.prototype.cancelExclusion = function () {
        this.props.onCancel();
    };
    CaseExclusion.prototype.render = function () {
        var _a, _b;
        return ((0, jsx_runtime_1.jsxs)("form", __assign({ className: "case-exclusion", onSubmit: function (e) { return e.preventDefault(); } }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "case-exclusion-subtitle" }, { children: ((_a = this.props) === null || _a === void 0 ? void 0 : _a.isChargeable)
                        ? 'This case will be considered non-chargeable, will be kept for reference, and charges are not submitted for billing. You can reverse this at any time.'
                        : 'This case will be considered chargeable. You will be able to code and submit for billing. You can reverse this any time before the case is submitted.' })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-exclusion-buttons-group" }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: this.cancelExclusion, className: "chakra-secondary-button" }, { children: "No, Cancel" })), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: this.caseToggleExclusion, className: (0, classnames_1["default"])('chakra-primary-button') }, { children: ((_b = this.props) === null || _b === void 0 ? void 0 : _b.isChargeable)
                                ? 'Yes, exclude case'
                                : 'Yes, include case' }))] }))] })));
    };
    CaseExclusion.displayName = 'CaseExclusion';
    CaseExclusion.defaultProps = {
        isChargeable: false,
        onStandaloneLaunch: function () { },
        onEmbeddedLaunch: function () { }
    };
    return CaseExclusion;
}(react_1["default"].Component));
exports.CaseExclusion = CaseExclusion;
//# sourceMappingURL=case-exclusion.js.map